export function adLightning(w) {
    var _a, _b, _c;
    // Ad Lightning Script
    if ((_a = w._fwnAnalytics3rd) === null || _a === void 0 ? void 0 : _a.adLightning) {
        return;
    }
    w._fwnAnalytics3rd = Object.assign(Object.assign({}, (w._fwnAnalytics3rd || {})), { adLightning: true });
    const s = w.document.createElement('script');
    s.defer = true;
    s.src = 'https://tagan.adlightning.com/firework/op.js';
    (_c = (_b = w.document) === null || _b === void 0 ? void 0 : _b.head) === null || _c === void 0 ? void 0 : _c.appendChild(s);
}
export function comScore(w) {
    var _a, _b;
    // comScore Tag
    if ((_a = w._fwnAnalytics3rd) === null || _a === void 0 ? void 0 : _a.comScore) {
        return;
    }
    w._fwnAnalytics3rd = Object.assign(Object.assign({}, (w._fwnAnalytics3rd || {})), { comScore: true });
    w._comscore = w._comscore || [];
    w._comscore.push({ c1: '7', c2: '34213477', c3: '1' });
    const s = w.document.createElement('script'), el = w.document.getElementsByTagName('script')[0];
    s.async = true;
    s.src =
        (w.document.location.protocol === 'https:' ? 'https://sb' : 'http://b') +
            '.scorecardresearch.com/beacon.js';
    (_b = el.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(s, el);
}
export function geoEdge(w) {
    var _a, _b;
    // GeoEdge Tag
    if ((_a = w._fwnAnalytics3rd) === null || _a === void 0 ? void 0 : _a.geoEdge) {
        return;
    }
    w._fwnAnalytics3rd = Object.assign(Object.assign({}, (w._fwnAnalytics3rd || {})), { geoEdge: true });
    w.grumi = {
        cfg: {
            advs: {
                '4873815558': true,
                '4898082219': true,
                '4898082384': true,
                '4904374504': true,
                '4914395957': true,
                '4954925202': true,
            },
        },
        key: 'c93e247a-e50c-4f00-b580-505908cbc804',
    };
    const s = w.document.createElement('script');
    const el = w.document.getElementsByTagName('script')[0];
    s.async = true;
    s.src =
        'https://rumcdn.geoedge.be/c93e247a-e50c-4f00-b580-505908cbc804/grumi-ip.js';
    (_b = el.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(s, el);
}
export function protectMedia(w) {
    // U10B20I8BZya4G6EAGfvffGLKjvL9oVO (tamil.oneindia.com)
    // V7OPrkpPXAmvjEYQ3Ufkm87XCE239Y9o (www.walkerplus.com)
    // CH-LU7k__aE_grc1C7FpiCKd8zCAtjB1 (film.ru)
    const trackSelection = ['U10B20I8BZ', 'V7OPrkpPXA', 'CH-LU7k__a'];
    return function (params) {
        var _a, _b;
        const app_id = params['app_id'];
        if (!trackSelection.includes((app_id || '').substr(0, 10))) {
            return;
        }
        // Protect Media Tag
        if ((_a = w._fwnAnalytics3rd) === null || _a === void 0 ? void 0 : _a.protectMedia) {
            return;
        }
        w._fwnAnalytics3rd = Object.assign(Object.assign({}, (w._fwnAnalytics3rd || {})), { protectMedia: true });
        const s = w.document.createElement('script');
        const el = w.document.getElementsByTagName('script')[0];
        s.async = true;
        s.src = `https://js.ad-score.com/score.min.js?pid=1000743#tid=traffic-id&l1=on-site-embed&ref=${encodeURIComponent(w.document.referrer)}&pub_domain=${encodeURIComponent(w.location.host)}&utid=unique-transaction-id&uid=device-id&uip=user-ip&cb=${Math.random()}`;
        (_b = el.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(s, el);
    };
}
